import { trackSelectItem } from '@theme/gtm-events';

/**
 * Delegates clicks on product cards sitewide to fire select_item.
 * data-gtm-item lives on <product-card> (the common ancestor of image + link).
 * An ancestor must have data-gtm-list-id and data-gtm-list-name.
 */
document.addEventListener('click', (e) => {
  const card = e.target.closest('[data-gtm-item]');
  if (!card) return;

  let itemData;
  try {
    itemData = JSON.parse(card.dataset.gtmItem);
  } catch (_) {
    return;
  }

  const listContainer = card.closest('[data-gtm-list-id]');
  const listId   = listContainer?.dataset.gtmListId   ?? '';
  const listName = listContainer?.dataset.gtmListName ?? '';

  // Determine 1-based index from position in DOM list.
  // Query by [data-gtm-item] (only on product-card) — not [data-product-id] which
  // also appears on the wrapping <li> in collection/search grids and doubles the index.
  const allItems = listContainer?.querySelectorAll('[data-gtm-item]');
  let index = 1;
  if (allItems) {
    index = Array.from(allItems).indexOf(card) + 1;
    if (index < 1) index = 1;
  }

  trackSelectItem(itemData, listId, listName, index);
}, true); // capture phase — fires before product-card's stopPropagation
